import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_87dvl89yd6: FaireBrandEntity = {
  token: "b_87dvl89yd6",
  type: "brand",
  name: "Island Dogs",
  location: "Owings Mills, MD, USA",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
